import { RouteRecordRaw } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireProvider } from '@/router/guards/authGuards';
import {
  redirectLoggedInSittersFromAccountCreation,
  checkSitterOnboardingRedirect,
  careTypeBeforeEnter,
  profileStepsBeforeEnter,
  profileCompleteBeforeEnter,
  setCareTypeGuard,
} from '@/router/guards/sitterOnboardingGuards';

import SitterOnboarding from '@/apps/sitter/SitterOnboarding.vue';
import SitterCreateForm from '@/apps/sitter/signup/account/SitterCreateForm.vue';
import SitterAddress from '@/apps/sitter/signup/address/SitterAddress.vue';
import SitterCareType from '@/apps/sitter/signup/careType/SitterCareType.vue';
import ProfileIntro from '@/apps/sitter/signup/profile/intro/ProfileIntro.vue';
import ProfileSteps from '@/apps/sitter/signup/profile/steps/ProfileSteps.vue';
import ProfileComplete from '@/apps/sitter/signup/profile/complete/ProfileComplete.vue';
import HousekeepingForm from '@/apps/sitter/signup/profile/housekeeping/HousekeepingForm.vue';
import PetCareForm from '@/apps/sitter/signup/profile/petCare/PetCareForm.vue';
import CompanionCareForm from '@/apps/sitter/signup/profile/companionCare/CompanionCareForm.vue';

const sitterOnboardingRoutes: RouteRecordRaw[] = [
  // Account creation - no auth required (new user signup), but redirect logged-in sitters
  {
    path: '/sitter/signup/account',
    name: 'sitter-create-form',
    component: SitterCreateForm,
    meta: { skipAuth: true },
    beforeEnter: combineGuards([redirectLoggedInSittersFromAccountCreation]),
  },
  // Parent route for remaining onboarding routes - require auth, redirect completed users away
  {
    path: '/sitter/signup',
    component: SitterOnboarding,
    meta: { sitterOnboardingLayout: true },
    beforeEnter: combineGuards([requireProvider, checkSitterOnboardingRedirect]),
    children: [
      {
        path: 'address',
        name: 'sitter-address',
        component: SitterAddress,
      },
      {
        path: 'profile/intro',
        name: 'sitter-profile-intro',
        component: ProfileIntro,
      },
      {
        path: 'care-type',
        name: 'sitter-care-type',
        component: SitterCareType,
        beforeEnter: careTypeBeforeEnter,
      },
      {
        path: 'profile/steps',
        name: 'sitter-profile-steps',
        component: ProfileSteps,
        beforeEnter: profileStepsBeforeEnter,
      },
      {
        path: 'profile/housekeeping',
        name: 'sitter-housekeeping',
        component: HousekeepingForm,
        beforeEnter: setCareTypeGuard('housekeeping'),
      },
      {
        path: 'profile/pet-care',
        name: 'sitter-pet-care',
        component: PetCareForm,
        beforeEnter: setCareTypeGuard('petCare'),
      },
      {
        path: 'profile/companion-care',
        name: 'sitter-companion-care',
        component: CompanionCareForm,
        beforeEnter: setCareTypeGuard('companionCare'),
      },
      {
        path: 'profile/complete',
        name: 'sitter-profile-complete',
        component: ProfileComplete,
        beforeEnter: profileCompleteBeforeEnter,
      },
    ],
  },
];

export default sitterOnboardingRoutes;
